import React from 'react'
import { injectIntl, intlShape } from 'react-intl'

const NewsHeader = (props) => {
  let date = props.fields.published.split('-');

  return (
    <header>
      <time>{parseInt(date[2], 10)+'.'+parseInt(date[1], 10)+'.'+parseInt(date[0], 10)}</time>
      <h2>{props.fields.title}</h2>
      <p className="lead">{props.fields.lead}</p>
      
      {props.tagsVisible && <div className="tags">
        {props.fields.tags && props.fields.tags.map((tag) => (
          <span key={tag}>{tag}</span>
        ))}
      </div>}
    </header>
  )
}

NewsHeader.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(NewsHeader)


// WEBPACK FOOTER //
// ./src/components/NewsHeader.js